

import { useMsal } from "@azure/msal-react";
// import { useDispatch } from "react-redux";
import { loginRequest } from "../configs/msal-config";
// import { setAccessToken, showError } from "../store/slices/formconfig";
import '../styles/unauthorized.css';
import { Cover, LoginBack } from "../configs";




export const Login = () => {
  const { instance } = useMsal();


  const handleLogin = () => {
    // This will redirect the user to the Azure AD login page
    // and then back to your application after successful authentication.
    instance.loginRedirect(loginRequest).catch(error => {
      console.error(`Login failed: ${error}`);
    });
  };
  return (
    <div style={{ display: 'flex' }}>

      <div className="left-panel" style={{ backgroundImage: `url(${LoginBack})`, backgroundSize: 'cover' }}>
        <div className="left-panel-content">
          <h1>Empower Partners with Transparency</h1>
          <p>Digitize Certificates, ensure compliance.</p>
        </div>

        <div className="illustration-container">
          <img src={Cover} height={300} alt="cover" />
        </div>

        <div className="left-panel-content">
          <p className="tagline">Manage Licenses</p>
        </div>
      </div>

      <div className="right-panel">
        <div>
          <div className="logo-section">
            {/* <img src={PCLOGO} className="bayer-logo" /> */}

          </div>

          <h2>Welcome to the <br /> License Review Portal</h2>
          <p>Log in to review Licenses.</p>
          <button className="sso-button" onClick={handleLogin}>Sign in with Bayer SSO</button>
        </div>
      </div>
    </div>
  )
}